import entitlementConfig from '../../shared/planEntitlements.json'

type EntitlementConfig = typeof entitlementConfig
type PlanMap = EntitlementConfig['plans']

export type CanonicalPlanId = keyof PlanMap
export type LegacyPlanId = keyof EntitlementConfig['legacyAliases']
export type PlanId = CanonicalPlanId | LegacyPlanId

export type PlanDefinition = PlanMap[CanonicalPlanId]

const planIds = Object.keys(entitlementConfig.plans) as CanonicalPlanId[]

export const PAID_PLANS = entitlementConfig.paidPlanIds as CanonicalPlanId[]
export const CANONICAL_PLAN_IDS = planIds
export const LEGACY_PLAN_ALIASES = entitlementConfig.legacyAliases
export const PLAN_ENTITLEMENTS = entitlementConfig.plans

export function isCanonicalPlanId(value?: string | null): value is CanonicalPlanId {
	return Boolean(value && planIds.includes(value as CanonicalPlanId))
}

export function normalizePlanId(planId?: string | null): CanonicalPlanId {
	if (!planId) return 'free'

	const aliasTarget =
		entitlementConfig.legacyAliases[
			planId as keyof typeof entitlementConfig.legacyAliases
		]
	const normalized = aliasTarget || planId

	return isCanonicalPlanId(normalized) ? normalized : 'free'
}

export function getPlanDefinition(planId?: string | null): PlanDefinition {
	return PLAN_ENTITLEMENTS[normalizePlanId(planId)]
}

export function getPlanDisplayName(planId?: string | null): string {
	return getPlanDefinition(planId).displayName
}
